export const createLeaguesRequests = (client) => ({
    listLeagues: async (params) => {
        const { data, meta, links } = await client.api.get("leagues", {
            params: params,
        });
        return { data, meta, links };
    },
    findLeague: async (params) => {
        const { data } = await client.api.get(`leagues/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createLeague: async (payload) => {
        const { data } = await client.api.create("leagues", payload);
        return { data };
    },
    updateLeague: async (payload) => {
        const { data } = await client.api.update("leagues", payload);
        return { data };
    },
    recalculateStandings: async (id) => {
        return await client.api.request({
            type: "leagues",
            url: `/leagues/${id}/recalculate`,
            method: "POST",
        });
    },
});
//# sourceMappingURL=index.js.map